var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Complete from '../AutoComplete';
import PlayerFilter from '../PlayerFilter';
import { Position } from './Position';
var PlayerComponent = function (_a) {
    var filter = _a.filter, modifyPlayerFilter = _a.modifyPlayerFilter, librariesResponse = _a.librariesResponse, onFilterApply = _a.onFilterApply, isHero = _a.isHero, disabled = _a.disabled, selectedTab = _a.selectedTab, isAgainstVillain = _a.isAgainstVillain;
    var isShow = function (part) {
        switch (part) {
            case 'position': {
                return !isAgainstVillain;
            }
            case 'name': {
                var allowedTab = [
                    'hands',
                    'handLine',
                    'report',
                    'handLineStats',
                    'handLineStatsForPlayers',
                    'handMistakeStats',
                ];
                return allowedTab.includes(selectedTab) && filter.source !== 'trainer';
            }
            case 'hands': {
                var allowedTab = [
                    'hands',
                    'handLine',
                    'report',
                    'handLineStats',
                    'handLineStatsForPlayers',
                    'handMistakeStats',
                ];
                return allowedTab.includes(selectedTab) && !isAgainstVillain;
            }
        }
    };
    var savedNames = useMemo(function () {
        if (isHero === null) {
            return __spreadArray(__spreadArray([], filter.heroAliasesNames, true), filter.villainAliasesNames, true);
        }
        else {
            return isHero ? filter.heroAliasesNames : filter.villainAliasesNames;
        }
    }, [isHero, selectedTab, filter.heroAliasesNames, filter.villainAliasesNames]);
    var names = useMemo(function () {
        if (isHero === null) {
            return __spreadArray(__spreadArray([], filter.heroArray, true), filter.villainArray, true);
        }
        else {
            return isHero ? filter.heroArray : filter.villainArray;
        }
    }, [isHero, selectedTab, filter.heroArray, filter.villainArray]);
    var aliases = useMemo(function () {
        if (isHero === null) {
            return __spreadArray(__spreadArray([], filter.heroAliases, true), filter.villainAliases, true);
        }
        else {
            return isHero ? filter.heroAliases : filter.villainAliases;
        }
    }, [isHero, selectedTab, filter.heroAliases, filter.villainAliases]);
    var player = useMemo(function () {
        if (isHero === null) {
            return ['hero', 'villain'];
        }
        else {
            return isHero ? ['hero'] : ['villain'];
        }
    }, [isHero, selectedTab]);
    return (_jsxs("div", { children: [isShow('position') && (_jsx(Position, { filter: filter, isHero: isHero, onFilterApply: onFilterApply, librariesResponse: librariesResponse, selectedTab: selectedTab })), isShow('name') && (_jsxs("p", { children: [_jsx(Complete, { filter: filter, isHero: isHero, modifyPlayerFilter: modifyPlayerFilter, savedNames: savedNames, isAgainstVillain: isAgainstVillain }), _jsx("div", { children: _jsx(PlayerFilter, { playerList: names, aliasesList: aliases, arr: player, onModify: modifyPlayerFilter, isHero: isHero, disabled: isHero ? disabled : false }) })] }))] }));
};
export default PlayerComponent;
